/* eslint-disable @nrwl/nx/enforce-module-boundaries */
/** Copyright 2023 Midas Healthcare Solutions - All Rights Reserved **/
import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { ControlZoneGuard, OverviewGroupGuard } from '@midas/overview/shell';
import { OrganizationNameRouteParam } from '@midas/shared/common';
import {
  createBreadcrumb,
  ShellGuard,
  OverviewGuard,
} from '@midas/shared/data-access';
import { TranslocoService } from '@ngneat/transloco';


export const MAIN_SHELL_ROUTES: Routes = [
  {
    path: '',
    canMatch: [ShellGuard],
    loadComponent: () => import('./toolbar/toolbar.component').then((m) => m.ToolbarComponent),
    loadChildren: () => [
      {
        path: `overview/:${OrganizationNameRouteParam}`,
        canMatch: [OverviewGuard, OverviewGroupGuard, ControlZoneGuard],
        providers: [OverviewGuard, OverviewGroupGuard, ControlZoneGuard],
        data: { breadcrumb: createBreadcrumb((org) => ({ label: org, url: `/overview/org/${org}` })) },
        loadChildren: () => import('@midas/overview/shell').then((m) => m.OVERVIEW_SHELL_ROUTES),
        title: () => inject(TranslocoService).translate(`The OverVIEW | MIDAS`),
      },
      { path: '**', pathMatch: 'prefix', redirectTo: 'overview/' },
    ],
  },
  {
    path: '',
    loadChildren: () => import('@midas/auth/shell').then((m) => m.AUTH_SHELL_ROUTES),
  },
  { path: '**', pathMatch: 'full', redirectTo:  ''},
];
